import ListingTitle from './ListingTitle';

export default ListingTitle;
